export default function Pricing() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const plans = [
    {
      name: '診断のみ',
      price: '¥0',
      note: '10分',
      includes: [
        '原因の切り分け',
        '優先順位の提示',
        '次の一手の提案'
      ],
      ctaLabel: '無料診断を申し込む',
      featured: false
    },
    {
      name: '改善設計（ライト）',
      price: '¥50,000〜',
      note: 'まず勝ち筋を作る',
      includes: [
        'TOP/LP構成案',
        '見出し・コピー案',
        'CTA/フォーム改善案',
        '計測チェック'
      ],
      ctaLabel: '相談する',
      featured: true
    },
    {
      name: '改修＋検証（スタンダード）',
      price: '¥150,000〜',
      note: '改修＋広告検証',
      includes: [
        '改修の実装（範囲定義）',
        'Google検索広告の検証設計',
        '2週間の改善サイクル',
        'レポート提出'
      ],
      ctaLabel: '相談する',
      featured: false
    }
  ];

  return (
    <section id="pricing" className="py-20 md:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            料金（迷わない設計）
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-2xl p-8 ${
                plan.featured
                  ? 'bg-gray-900 text-white shadow-2xl transform md:scale-105'
                  : 'bg-gray-50 text-gray-900'
              }`}
            >
              <div className="text-center mb-6">
                <h3 className={`text-xl font-bold mb-2 ${plan.featured ? 'text-white' : 'text-gray-900'}`}>
                  {plan.name}
                </h3>
                <div className={`text-4xl font-black mb-1 ${plan.featured ? 'text-white' : 'text-gray-900'}`}>
                  {plan.price}
                </div>
                <p className={`text-sm ${plan.featured ? 'text-gray-300' : 'text-gray-600'}`}>
                  {plan.note}
                </p>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.includes.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`ri-checkbox-circle-fill text-lg ${
                        plan.featured ? 'text-white' : 'text-gray-900'
                      }`}></i>
                    </div>
                    <span className={`text-sm ${plan.featured ? 'text-gray-200' : 'text-gray-600'}`}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => scrollToSection('cta')}
                className={`w-full py-3 rounded-lg font-bold text-sm transition-all whitespace-nowrap cursor-pointer ${
                  plan.featured
                    ? 'bg-white text-gray-900 hover:bg-gray-100'
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                {plan.ctaLabel}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
